import React from "react";
import { ChartDonut } from "@ds/ds-snam/react";
import { IContract } from "dataModels/contract";
import { useTranslation } from "react-i18next";

interface IContractSlotChartProps{
    contract:IContract
}
const ContractSlotChart:React.FC<IContractSlotChartProps> = (props):JSX.Element=>{
    const {contract} = props;
    const {t} = useTranslation(['contract']); 
    return (

             <ChartDonut
                chartTitle={t('contract.contractData.chart.chartTitle')}
                chartDescription={contract.slot+" slots"}
                icon={undefined}/*"icon-conversation-2"*/
                chartData={contract.chartData}
                donutVariant="bold"
                chartAriaLabel=""
                showPercentage={false}
                showValue={false}
                hideLegend={false}
                hideLegendTitle={false}
                hideChartsTitle={false}
                hideChartsDescription={false}
            />

    )
}
export default ContractSlotChart;